import { useState } from 'react';
import { CONTACT_IMAGE } from '@config/assets';
import styles from './Partenaire.module.css';

export default function Partenaire() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        setSubmitted(true);
        form.reset();
      })
      .catch(() => alert('Une erreur est survenue, veuillez réessayer.'));
  };

  return (
    <>
      {/* ── 1. Page Header ──────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>
            Devenir Partenaire de Bohío Kiskeya
          </h1>
          <p className={styles.heroSubtitle}>
            Construire ensemble une agriculture durable.
          </p>
          <div className={styles.heroBody}>
            <p>
              Bohío Kiskeya développe des partenariats avec institutions
              publiques, fondations, entreprises et acteurs de la diaspora
              souhaitant soutenir la structuration agricole haïtienne.
            </p>
            <p>
              En soutenant Bohío Kiskeya, vous contribuez à structurer une
              filière agricole locale, née du terrain, au service des producteurs
              et des marchés.
            </p>
            <p>
              Nous recherchons des partenaires prêts à investir dans une
              agriculture haïtienne plus organisée, plus résiliente et plus
              juste.
            </p>
          </div>
        </div>
      </section>

      {/* ── 2. Pourquoi s'engager avec nous ? ─────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>
            Pourquoi s&rsquo;engager avec nous&nbsp;?
          </h2>

          <div className={styles.pourquoiLayout}>
            <div className={styles.pourquoiText}>
              <p className={styles.sectionSubheading}>
                Une initiative ancrée dans le territoire
              </p>
              <div className={styles.bodyGray}>
                <p>
                  Bohío Kiskeya est né en 2019 dans la région du Bas Plateau, à
                  partir d&rsquo;un besoin concret exprimé par les agriculteurs
                  eux-mêmes&nbsp;: mieux valoriser leurs produits et faciliter
                  l&rsquo;accès aux marchés urbains.
                </p>
                <p>Notre approche repose sur&nbsp;:</p>
                <ul className={styles.dashList}>
                  <li>l&rsquo;écoute des besoins du terrain</li>
                  <li>des solutions simples, adaptées et progressives</li>
                  <li>
                    une vision de long terme&nbsp;: structurer une agriculture
                    durable, viable économiquement et utile aux populations
                    locales.
                  </li>
                </ul>
              </div>
            </div>

            <img
              src={CONTACT_IMAGE}
              alt="Équipe Bohío Kiskeya autour d'une table de travail"
              className={styles.pourquoiImage}
            />
          </div>
        </div>
      </section>

      {/* ── 3. Types de partenariats ─────────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Types de partenariats</h2>
          <p className={styles.sectionSubheading}>
            Institutions, fondations, entreprises, diaspora
          </p>
          <div className={styles.bodyGray}>
            <p>
              Les besoins sont variés et complémentaires. Nous développons des
              partenariats autour de&nbsp;:
            </p>
            <ul className={styles.dashList}>
              <li>
                l&rsquo;organisation de la filière&nbsp;: appui à la logistique,
                à la structuration des producteurs, à la mise en place
                d&rsquo;outils simples de suivi
              </li>
              <li>
                la qualité et la formation&nbsp;: accompagnement des producteurs
                sur la charte qualité, les pratiques agricoles, la gestion des
                récoltes
              </li>
              <li>
                l&rsquo;investissement dans les infrastructures&nbsp;: stockage,
                transport, équipements de base
              </li>
              <li>
                la mise en marché&nbsp;: collaboration avec des distributeurs,
                commerces, réseaux de la diaspora.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── 4. Ce que nous garantissons ──────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>
            Ce que nous garantissons
          </h2>
          <p className={styles.sectionSubheading}>
            Transparence, ancrage et accompagnement
          </p>
          <div className={styles.bodyGray}>
            <p>En tant que partenaire, vous bénéficiez&nbsp;:</p>
            <ul className={styles.dashList}>
              <li>
                d&rsquo;une visibilité claire sur la zone d&rsquo;action (Bas
                Plateau, département du Centre)
              </li>
              <li>
                d&rsquo;un suivi régulier des activités et des résultats
              </li>
              <li>
                d&rsquo;un interlocuteur identifié côté Bohío Kiskeya pour
                construire et suivre le partenariat.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── 5. Entrer en contact ────────────────── */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Entrer en contact</h2>
          <p className={styles.sectionSubheading}>
            Construisons ensemble un partenariat utile
          </p>
          <div className={styles.bodyGray}>
            <p>
              Vous représentez une institution, une fondation, une entreprise ou
              un collectif de la diaspora intéressé par la structuration agricole
              en Haïti&nbsp;?
            </p>
            <p>
              Échangeons sur vos objectifs et sur la manière dont Bohío Kiskeya
              peut devenir un point d&rsquo;ancrage pour vos actions.
            </p>
          </div>
          <a href="#contact-form" className={styles.ctaButton}>
            Échanger avec Bohío Kiskeya
          </a>
        </div>
      </section>

      {/* ── 6. Nous contacter – Netlify Form ──── */}
      {/* <section className={styles.formSection} id="contact-form">
        <div className={styles.container}>
          <h2 className={styles.formHeading}>Nous contacter</h2>

          {submitted ? (
            <div className={styles.successMessage}>
              <p>
                Merci pour votre message&nbsp;! Nous reviendrons vers vous très
                prochainement.
              </p>
            </div>
          ) : (
            <form
              name="partenaire"
              method="POST"
              data-netlify="true"
              netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
              className={styles.form}
            >

              <input type="hidden" name="form-name" value="partenaire" />
              <p className={styles.hidden}>
                <label>
                  Don&rsquo;t fill this out:{' '}
                  <input name="bot-field" />
                </label>
              </p>


              <div className={styles.formRow}>
                <div className={styles.formField}>
                  <label htmlFor="first-name" className={styles.formLabel}>
                    Prénom
                  </label>
                  <input
                    id="first-name"
                    type="text"
                    name="first-name"
                    placeholder="Jane"
                    className={styles.formInput}
                    required
                  />
                </div>
                <div className={styles.formField}>
                  <label htmlFor="last-name" className={styles.formLabel}>
                    Nom
                  </label>
                  <input
                    id="last-name"
                    type="text"
                    name="last-name"
                    placeholder="Smitherton"
                    className={styles.formInput}
                    required
                  />
                </div>
              </div>


              <div className={styles.formField}>
                <label htmlFor="email" className={styles.formLabel}>
                  Adresse email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="email@example.com"
                  className={styles.formInput}
                  required
                />
              </div>


              <div className={styles.formField}>
                <label htmlFor="message" className={styles.formLabel}>
                  Votre message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={6}
                  placeholder="Parlez-nous de vos objectifs..."
                  className={`${styles.formInput} ${styles.formTextarea}`}
                  required
                />
              </div>


              <button type="submit" className={styles.submitButton}>
                Envoyer
              </button>
            </form>
          )}
        </div>
      </section> */}
    </>
  );
}
